module.exports = __webpack_public_path__ + "img/offers8.a2bf0596.webp";